import __request__ from 'routing/request';
interface Context {
    readonly streams: {
        readonly [_key: string]: ContextEntity;
    };
    readonly event_definitions: {
        readonly [_key: string]: ContextEntity;
    };
}
interface EventsSearchFilter {
    readonly alerts: 'include' | 'exclude' | 'only';
    readonly extra_filters: {
        readonly [_key: string]: string[];
    };
    readonly aggregation_timerange: TimeRange;
    readonly id: string[];
    readonly event_definitions: string[];
    readonly priority: string[];
    readonly key: string[];
}
interface EventsSearchParameters {
    readonly filter: EventsSearchFilter;
    readonly sort_direction: 'asc' | 'desc';
    readonly per_page: number;
    readonly timerange: TimeRange;
    readonly sort_unmapped_type: string;
    readonly query: string;
    readonly sort_by: string;
    readonly page: number;
}
interface EventsSearchResult {
    readonly total_events: number;
    readonly duration: number;
    readonly used_indices: string[];
    readonly context: Context;
    readonly parameters: EventsSearchParameters;
    readonly events: Event[];
}
interface UsedSearchFilter {
}
interface EventDto {
    readonly timerange_end: string;
    readonly timestamp_processing: string;
    readonly origin_context: string;
    readonly scores: {
        readonly [_key: string]: number;
    };
    readonly replay_info: EventReplayInfo;
    readonly streams: string[];
    readonly source_streams: string[];
    readonly source: string;
    readonly priority: number;
    readonly message: string;
    readonly associated_assets: string[];
    readonly group_by_fields: {
        readonly [_key: string]: string;
    };
    readonly key_tuple: string[];
    readonly alert: boolean;
    readonly event_definition_type: string;
    readonly event_definition_id: string;
    readonly id: string;
    readonly fields: {
        readonly [_key: string]: string;
    };
    readonly key: string;
    readonly timestamp: string;
    readonly timerange_start: string;
    readonly aggregation_conditions: {
        readonly [_key: string]: number;
    };
}
interface BulkEventsByIds {
    readonly event_ids: string[];
}
interface EventReplayInfo {
    readonly timerange_end: string;
    readonly query: string;
    readonly streams: string[];
    readonly filters: UsedSearchFilter[];
    readonly timerange_start: string;
}
interface ContextEntity {
    readonly description: string;
    readonly id: string;
    readonly remediation_steps: string;
    readonly title: string;
}
interface EventMap {
    readonly [_key: string]: Event;
}
interface TimeRange {
    readonly type: string;
}
interface Bucket {
    readonly count: number;
    readonly start_date: string;
}
interface EventsHistogramResult {
    readonly buckets: EventsBuckets;
}
interface Event {
    readonly event: EventDto;
    readonly index_name: string;
    readonly index_type: string;
}
interface EventsBuckets {
    readonly alerts: Bucket[];
    readonly events: Bucket[];
}
/**
 * Get multiple events by IDs
 */
export function getByIds(body?: BulkEventsByIds): Promise<EventMap> {
    return __request__('POST', '/events/byIds', body, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Build histogram of events over time
 */
export function histogram(JSONbody?: EventsSearchParameters): Promise<EventsHistogramResult> {
    return __request__('POST', '/events/histogram', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Search events
 */
export function search(JSONbody?: EventsSearchParameters): Promise<EventsSearchResult> {
    return __request__('POST', '/events/search', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get event by ID
 */
export function getById(event_id?: string): Promise<Event> {
    return __request__('GET', `/events/${event_id}`, null, {}, {
        'Accept': ['application/json']
    });
}
